"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueByPathKey = void 0;
/**
 * 获取路径模式 Key 对应数据
 * @param record
 * @param pathKey
 */
function getValueByPathKey(record, pathKey) {
    if (typeof pathKey !== "string") {
        return undefined;
    }
    // 兼容包含点的 key
    if (typeof record[pathKey] !== "undefined") {
        return record[pathKey];
    }
    var path = pathKey.split(".");
    var value = record[path.shift()];
    while (typeof value === "object" && value !== null && path.length > 0) {
        value = value[path.shift()];
    }
    return value;
}
exports.getValueByPathKey = getValueByPathKey;
//# sourceMappingURL=get-value-by-path-key.js.map